import React, { Component } from "react";
import Verification from "../../../components/Verification/Verification";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : SupportForm
Description : Componente que invoca al componente Support, para la creación y consulta de reportados.
Date Autor Modification
================================================================================
1/10/2021 Santiago Coca Rojas Creación – Se llama al componente Reported
================================================================================ */
class VerificationForm extends Component {
    render() {
        return (
            <Verification />
        )
    }
}

export default VerificationForm;